import React from 'react';
import { Link } from 'react-router-dom';
import { Clock, ArrowRight, Sparkles } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const ComingSoonPage = () => {
  return (
    <div className="min-h-screen flex flex-col" style={{ background: 'var(--bg-main)' }}>
      <Header />

      <main className="flex-1">
        <section className="px-5 md:px-6 lg:px-12 py-20 md:py-28">
          <div className="max-w-2xl mx-auto text-center">
            <div className="inline-flex items-center justify-center w-14 h-14 rounded-full mb-6" style={{ background: 'var(--bg-accent-soft)', color: 'var(--green-main)' }} aria-hidden="true">
              <Clock className="w-6 h-6" />
            </div>

            <span className="inline-block px-3 py-1 rounded-full text-[10px] font-black uppercase tracking-widest mb-5" style={{ background: '#111827', color: '#FFF', letterSpacing: '0.1em' }}>
              ÇOK YAKINDA
            </span>

            <h1 className="text-3xl md:text-4xl font-black tracking-tight mb-4" style={{ color: 'var(--text-primary)' }} data-testid="coming-soon-title">
              Bu kategori çok yakında yayında
            </h1>

            <p className="text-base md:text-lg font-medium leading-relaxed mb-10" style={{ color: 'var(--text-secondary)' }} data-testid="coming-soon-description">
              Kozmetik, gıda ve 2. el araç kategorilerinde test süreçleri yakında başlıyor.
              Yayına alındıklarında bu sayfa ürünlerle güncellenecektir.
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 mb-10">
              {[
                { label: 'Kozmetik', badge: 'ÇOK YAKINDA' },
                { label: 'Gıda', badge: 'ÇOK YAKINDA' },
                { label: '2. El Araç', badge: 'ÇOK YAKINDA', emphasis: true },
              ].map(c => (
                <div key={c.label} className="border rounded-xl p-4 flex flex-col items-center gap-2" style={{ borderColor: c.emphasis ? '#C7A15A' : 'var(--border-soft)', background: '#FAFAF7' }} data-testid={`preview-${c.label}`}>
                  <span className="text-sm font-bold" style={{ color: 'var(--text-primary)' }}>{c.label}</span>
                  <span className="inline-flex items-center px-2 py-0.5 rounded-full text-[9px] font-black uppercase tracking-widest" style={{
                    background: c.emphasis ? 'linear-gradient(135deg, #C7A15A 0%, #A87F35 100%)' : '#111827',
                    color: '#FFF',
                    letterSpacing: '0.08em',
                  }}>
                    {c.badge}
                  </span>
                </div>
              ))}
            </div>

            <Link to="/products"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-lg text-sm font-bold transition-all hover:-translate-y-0.5 hover:shadow-md focus-visible:ring-2 focus-visible:ring-offset-2 outline-none"
              style={{ background: 'var(--green-main)', color: '#FFF' }}
              data-testid="coming-soon-cta">
              Yayındaki Ürünleri İncele <ArrowRight className="w-4 h-4" />
            </Link>

            <p className="text-xs mt-6 flex items-center justify-center gap-1.5" style={{ color: 'var(--text-muted)' }}>
              <Sparkles className="w-3 h-3" />
              Tüm test süreçleri bağımsız yürütülür.
            </p>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default ComingSoonPage;
